import "./Schedule.scss";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import Popup from "reactjs-popup";
import DatePicker from "react-datepicker";
import { CiWarning } from "react-icons/ci";
import { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as momentTimezone from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";

import AlertModal from "./AlertModal";
import SwarmModal from "./SwarmModal";
import { timeDisplayFormat, timeSlots } from "../../utils/utils";
import linguitoPNG from "../../assets/images/icons/linguito.png";
import InputDatepicker from "../elements/NewInputs/InputDatepicker";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { loadUserStorage, postCheckClass, postClass, putCancelClass } from "../../store/middleware";

function ModalSchedule(props) {
  const {
    noShow,
    title,
    planId,
    userClass,
    teacherId,
    studentId,
    openSchedule,
    closeSchedule,
    editClass = false,
    sequentialScheduleId,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);

  const [totalCount] = useState(0);
  const [alertMsg, setAlertMsg] = useState("");
  const [httpCode, setHttpCode] = useState("");
  const [focus, setFocus] = useState("Regular");
  const [languages, setLanguages] = useState([]);
  const [repeatEnd, setRepeatEnd] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [openSwarm, setOpenSwarm] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [nativoBtn, setNativoBtn] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);
  const [scheduledEnd, setScheduledEnd] = useState("");
  const [bilingueBtn, setBilingueBtn] = useState(false);
  const [studentPlanId, setStudentPlanId] = useState(0);
  const [textSpecific, setTextSpecific] = useState(null);
  const [scheduledDate, setScheduledDate] = useState("");
  const [scheduledStart, setScheduledStart] = useState("");
  const [repeatWeekDays, setRepeatWeekDays] = useState([]);
  const [lingoLanguage, setLingoLanguage] = useState(null);
  const [lingoLanguageId, setLingoLanguageId] = useState(0);
  const [isVisibleText, setIsVisibleText] = useState(false);
  const [numberOfClasses, setNumberOfClasses] = useState(1);
  const [alternativeTimes, setAlternativeTimes] = useState([]);
  const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [outLimitChangeAlert, setOutLimitChangeAlert] = useState(false);
  const [alternativeTimesMessage, setAlternativeTimesMessage] = useState("");

  const handlerListLanguage = ({ languages }) => {
    if (plans?.length === 1) planSingle(plans[0].id);
    if (languages.length === 1) setLingoLanguageId(languages[0].lingoLanguageId);

    setLanguages(languages);
  };

  const loadInfos = async () => {
    const lingoLanguages = plans?.flatMap((plan) => plan.studentPlanLanguages) || [];
    const uniqueLanguages = Array.from(new Set(lingoLanguages.map((lang) => lang.lingoLanguage.description)));

    const newArrayLingoLang = uniqueLanguages.map((description) =>
      lingoLanguages.find((lang) => lang.lingoLanguage.description === description),
    );

    handlerListLanguage({ languages: newArrayLingoLang });

    if (!editClass) return;

    const scheduledStartDateTime =
      moment(moment(userClass.scheduledDate).format("YYYY-MM-DD") + "T" + userClass.scheduledStartTime).diff(
        moment(),
        "minutes",
      ) < 60;

    setOutLimitChangeAlert(scheduledStartDateTime);

    setLingoLanguageId(userClass.lingoLanguageId);
    setScheduledStart(userClass.scheduledStartTime);
    setScheduledDate(moment(userClass.scheduledDate));
    setFocus(userClass.classScheduleDetails[0]?.focus);
    setNumberOfClasses(userClass.sequentialScheduleClassesCount);
    setTextSpecific(userClass.classScheduleDetails[0]?.specificSubject);
    userClass.classScheduleDetails[0]?.focus?.toLowerCase() === "specific" && setIsVisibleText(true);

    if (userClass.teacherLanguageType === "native") {
      setNativoBtn(true);
      setBilingueBtn(false);
    }
    if (userClass.teacherLanguageType === "bilingual") {
      setNativoBtn(false);
      setBilingueBtn(true);
    }
  };

  const closeAlert = () => {
    setFocus("Regular");
    setScheduledDate("");
    setLingoLanguageId(0);
    setScheduledStart("");
    setNumberOfClasses(1);
    setTextSpecific(null);
    setIsVisibleText(false);
    setScheduledEnd(timeSlots[25] + ":00");
    setScheduledStart(timeSlots[24] + ":00");

    setRedirect(false);
    setOpenAlert(false);
    setIsButtonDisabled(false);
    dispatch(loadUserStorage(true, false, "ModalSchedule"));

    if (redirect) closeSchedule();
    else setOpenSwarm(false);
  };

  const buttonLanguageHandleChange = (e, obj) => {
    setLingoLanguageId(obj.id);
    setLingoLanguage(obj);
    const filterPlan = filterGetPlan();

    if (plans?.length === 1) {
      planSingle(filterPlan[0].id);
      return <span>{filterPlan[0].plan.nameEnglish}</span>;
    } else {
      planSingle(plans.filter((plan) => plan.studentPlanLanguages[0].lingoLanguage.id === obj.id)[0].id);
    }
  };

  const planSingle = (id) => {
    if (id === studentPlanId) return;
    setStudentPlanId(id);
  };

  const btnRepeatHandleChange = (e) => {
    if (e.target.name == "yes") {
      setShowRepeat(true);
    } else {
      setShowRepeat(false);
    }
  };

  const btnTeacherHandleChange = (e) => {
    if (e.target.name == "nativo") {
      setBilingueBtn(false);
      setNativoBtn(true);
    } else {
      setBilingueBtn(true);
      setNativoBtn(false);
    }
  };

  const btnHandleWeekDay = (e) => {
    for (var i = 0; i < repeatWeekDays.length; i++) {
      if (parseInt(e.target.value) === repeatWeekDays[i].weekDayId) {
        repeatWeekDays.splice(i, 1);
        e.target.className = "";
        return;
      }
    }

    e.target.className = "active";
    if (repeatWeekDays.length > 0) {
      setRepeatWeekDays([...repeatWeekDays, { weekDayId: parseInt(e.target.value) }]);
    } else {
      setRepeatWeekDays([{ weekDayId: parseInt(e.target.value) }]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "scheduledStart") {
      for (var item = 0; item < timeSlots.length; item++) {
        if (timeSlots[item] + ":00" == value + ":00") {
          if (numberOfClasses == 0) {
            calculaQtdAulas(true);
            continue;
          }
        }
      }
      setScheduledStart(value);
    } else if (name === "numberOfClasses") {
      if (value == "Select") {
        setScheduledEnd("12:30:00");
      } else {
        calculaQtdAulas(true);
      }
      setNumberOfClasses(value);
    } else if (name === "textSpecific") {
      setTextSpecific(value);
    }
  };

  const handlerSubjectEspecific = (e) => {
    var { value } = e.target;

    setFocus(value);
    setTextSpecific(null);
    setIsVisibleText(value === "Specific" ? true : false);
  };

  const setDate = (birth_date) => {
    setScheduledDate(birth_date);
  };

  const btnScheduleSubmit = () => {
    if (!validateForm()) {
      setIsButtonDisabled(false);
      return;
    }

    let postScheduleObject = [];
    if (showRepeat) {
      postScheduleObject = {
        studentPlanId: parseInt(studentPlanId),
        studentId: parseInt(user.studentId),
        lingoLanguageId: parseInt(lingoLanguageId),
        focus: focus,
        specificSubject: textSpecific,
        scheduledStart: moment(scheduledDate).format("YYYY-MM-DD") + "T" + scheduledStart + ".000",
        scheduledEnd:
          moment(scheduledDate).format("YYYY-MM-DD") + "T" + moment(scheduledEnd).format("hh:mm:ss") + ".000",
        numberOfClasses: parseInt(numberOfClasses),
        repeat: showRepeat,
        repeatWeekDays: repeatWeekDays,
        repeatEnd: repeatEnd,
      };
    } else {
      postScheduleObject = {
        studentPlanId: Number(studentPlanId),
        studentId: parseInt(user.studentId),
        lingoLanguageId: parseInt(lingoLanguageId),
        focus: focus,
        specificSubject: textSpecific,
        scheduledStart: moment(scheduledDate).format("YYYY-MM-DD") + "T" + scheduledStart + ".000",
        scheduledEnd:
          moment(scheduledDate).format("YYYY-MM-DD") + "T" + moment(scheduledEnd).format("hh:mm:ss") + ".000",
        numberOfClasses: parseInt(numberOfClasses),
        repeat: showRepeat,
      };
    }

    if (ruleDisplayNativeBilingue("studentlevel")) {
      postScheduleObject.typeLanguage = nativoBtn ? "native" : "bilingual";
    } else if (postScheduleObject.lingoLanguageId === 1) {
      postScheduleObject.typeLanguage = nativoBtn ? "native" : "bilingual";
    } else if (postScheduleObject.lingoLanguageId === 4) {
      postScheduleObject.typeLanguage = nativoBtn ? "native" : "bilingual";
    }

    setIsButtonDisabled(true);
    dispatch(
      postCheckClass({
        studentId: postScheduleObject.studentId,
        studentPlanId: postScheduleObject.studentPlanId,
        lingoLanguageId: postScheduleObject.lingoLanguageId,
        scheduledStart: postScheduleObject.scheduledStart,
        numberOfClasses: postScheduleObject.numberOfClasses,
      }),
    )
      .then(() => postSchedule(null, postScheduleObject))
      .catch((res) => {
        if (res.status === 409) {
          const key = t("MESSAGE_LANGUAGE");
          const message = res.data.error.message[key].slice(0, -1);
          const alternativeTimes = message.split(",");
          const alternativeTimesMessage = alternativeTimes[0];
          alternativeTimes.shift();
          setAlternativeTimesMessage(alternativeTimesMessage);
          setAlternativeTimes(alternativeTimes);
          setOpenSwarm(true);
          setIsButtonDisabled(false);
        }
      });
  };

  const postSchedule = (newTime, data) => {
    setOpenSwarm(false);
    const postObj = Object.assign({}, data);
    if (newTime) {
      postObj.scheduledStart = newTime;
    }
    dispatch(postClass(postObj))
      .then((res) => {
        if (res?.data?.success) {
          setHttpCode("");
          setRedirect(true);
          setOpenAlert(true);
          setIsButtonDisabled(false);
          setAlertMsg(t("BTN_SCHEDULE_ADDED"));
          setAlertTitle(t("BTN_CLASS_SCHEDULED"));
        }
      })
      .catch((err) => {
        const languageFormatted =
          language === "pt" ? "pt_BR" : language === "es" ? "es" : language === "fr" ? "fr" : "en_US";

        const message = err?.response?.data?.error?.message;
        const hasMessage = message ? message[languageFormatted] : t("ERROR");

        setOpenAlert(true);
        setAlertMsg(hasMessage);
        setAlertTitle(t("ERROR"));
        setIsButtonDisabled(false);
        setHttpCode(err?.response?.data?.error?.httpCode);
      });
  };

  const validateForm = () => {
    if (lingoLanguageId == "" || lingoLanguageId == null || lingoLanguageId == undefined || lingoLanguageId == 0) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_LANG"));
      setHttpCode("erro");

      return false;
    }

    if (totalCount >= 2 && studentPlanId == 0) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_PLAN"));
      setHttpCode("erro");

      return false;
    }

    if (studentPlanId == "" || studentPlanId == null || studentPlanId == undefined) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_PLAN"));
      setHttpCode("erro");

      return false;
    }

    if (focus == "" || focus == null || focus == undefined || focus == 0) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_FOCUS"));
      setHttpCode("erro");

      return false;
    }

    if (isVisibleText && textSpecific === null) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setHttpCode("erro");
      setAlertMsg(t("VALIDATE_SCHEDULE_FOCUS"));

      return false;
    }

    if (scheduledDate == "" || scheduledDate == null || scheduledDate == undefined || scheduledDate == 0) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_DATE"));
      setHttpCode("erro");

      return false;
    }

    if (scheduledStart == "" || scheduledStart == null || scheduledStart == undefined || scheduledStart == 0) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_START"));
      setHttpCode("erro");

      return false;
    }

    if (numberOfClasses == "" || numberOfClasses == null || numberOfClasses == undefined || numberOfClasses == 0) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_NUM_CLASSES"));
      setHttpCode("erro");

      return false;
    }

    if (nativoBtn === false && bilingueBtn === false && ruleDisplayNativeBilingue()) {
      setAlertTitle(t("ERROR"));
      setOpenAlert(true);
      setAlertMsg(t("VALIDATE_SCHEDULE_NATIVE_BILINGUE"));
      setHttpCode("erro");

      return false;
    }

    if (showRepeat) {
      if (
        repeatWeekDays === "" ||
        repeatWeekDays === null ||
        repeatWeekDays === undefined ||
        repeatWeekDays.length === 0
      ) {
        setAlertTitle(t("ERROR"));
        setOpenAlert(true);
        setAlertMsg(t("VALIDATE_SCHEDULE_WEEKREPEAT"));
        setHttpCode("erro");

        return false;
      }

      if (repeatEnd == "" || repeatEnd == null || repeatEnd == undefined || repeatEnd == 0) {
        setAlertTitle(t("ERROR"));
        setOpenAlert(true);
        setAlertMsg(t("VALIDATE_SCHEDULE_REPEATEND"));
        setHttpCode("erro");

        return false;
      }
    }

    return true;
  };

  const handleSubmitEdit = (e) => {
    e.preventDefault();

    let startime = "";
    let startdate = "";

    if (scheduledStart === "") {
      startime = userClass?.scheduledStartTime;
    } else {
      startime = scheduledStart;
    }
    if (scheduledDate === "") {
      startdate = userClass?.scheduledDate;
    } else {
      startdate = scheduledDate;
    }

    const req = {
      studentId,
      studentPlanId: planId,
      lingoLanguageId: parseInt(lingoLanguageId),
      teacherId: teacherId === 0 ? null : parseInt(teacherId),
      sequentialScheduleId,
      focus,
      scheduledStart: `${momentTimezone(startdate).format("YYYY-MM-DD")}T${startime}.000`,
      numberOfClasses: userClass?.sequentialScheduleClassesCount,
      specificSubject: userClass?.classScheduleDetails.specificSubject,
      applyToRecurrence: false,
      status: noShow ? "noShow" : teacherId ? "accepted" : "pending",
      typeLanguage: bilingueBtn ? "bilingual" : "native",
    };

    if (user?.role === "student") {
      req.teacherId = null;
    }
    if (textSpecific) {
      req.specificSubject = textSpecific;
    }
    if (numberOfClasses !== 1) {
      req.numberOfClasses = Number(numberOfClasses);
    }
    dispatch(putCancelClass(req))
      .then((res) => {
        if (res.success) {
          closeSchedule();
          user?.role !== "student" && navigate(-1);
        }
      })
      .catch((err) => {
        if (err.response.data.error.httpCode === 409) {
          const languageFormatted =
            language === "pt" ? "pt_BR" : language === "es" ? "es" : language === "fr" ? "fr" : "en_US";

          const message = err?.response?.data?.error?.message;
          const hasMessage = message ? message[languageFormatted] : t("ERROR");

          setOpenAlert(true);
          setAlertMsg(hasMessage);
          setAlertTitle(t("ERROR"));
          setHttpCode(err.response.data.error.httpCode);
        } else {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertMsg(
            err.response.data.error
              ? err.response.data.error
              : err.response.data.error[0]?.message
              ? err.response.data.error[0]?.message
              : t("SOMETHING_WENT_WRONG"),
          );
        }
      });
  };

  const filterGetPlan = () => {
    return plans?.filter((item) => {
      if (lingoLanguage === null) {
        return item.studentPlanLanguages.indexOf(lingoLanguage);
      }

      return item.studentPlanLanguages.find((val) => val.lingoLanguage.id === lingoLanguage.id);
    });
  };

  const getPlan = () => {
    const resetPlan = () => {
      setStudentPlanId(0);
      setLingoLanguageId(0);
      setLingoLanguage(null);
    };

    const filterPlan = filterGetPlan();
    if (filterPlan?.length === 1) {
      return (
        <div className="planNameDiv">
          <span>{filterPlan[0].plan.nameEnglish}</span>
          {languages?.filter((lang) => lang.studentPlanId === Number(studentPlanId)).length > 1 &&
            lingoLanguageId !== 0 &&
            plans?.length > 1 && <span onClick={() => resetPlan()}>{t("BACK")}</span>}
        </div>
      );
    }

    const handlePlanLanguage = (e) => {
      setStudentPlanId(e.target.value);

      const lang = languages.filter((lang) => lang.studentPlanId === Number(e.target.value))[0];
      setLingoLanguageId(lang.lingoLanguage.id);
      setLingoLanguage(lang.lingoLanguage);
    };

    return (
      <select required name="studentPlanId" value={studentPlanId} onChange={(e) => handlePlanLanguage(e)}>
        <option value="">{t("SELECT")}</option>
        {filterPlan?.map((planTeste, index) => {
          return (
            <option value={planTeste.id} key={index}>
              {planTeste.plan.nameEnglish}
            </option>
          );
        })}
      </select>
    );
  };

  const calculaQtdAulas = (setState) => {
    let qtd = numberOfClasses;

    let hourClass = scheduledStart === "" ? " " + filteredTimeSlots[0] + ":00" : scheduledStart;

    hourClass = hourClass.replace(" ", "");

    const date = scheduledDate !== "" ? moment(scheduledDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    let dataStart = moment(date).add(3, "hours").format("YYYY-MM-DD");
    let dataFim = moment(dataStart + "T" + hourClass + ".000").format(
      `YYYY-MM-DD ${timeDisplayFormat(user?.timeDisplayFormat)}`,
    );
    if (qtd > 0 && hourClass !== "") {
      qtd = 30 * qtd;
      dataFim = moment(dataFim, `YYYY-MM-DD ${timeDisplayFormat(user?.timeDisplayFormat)}`).add(qtd, "minutes");
    }

    if (setState == true) {
      setScheduledEnd(dataFim);
    }
    return moment(dataFim).format(timeDisplayFormat(user?.timeDisplayFormat));
  };

  const renderStartTime = () => {
    return (
      <select name="scheduledStart" value={scheduledStart} onChange={(e) => handleChange(e)}>
        {filteredTimeSlots.length &&
          filteredTimeSlots?.map((timeSlots, index) => {
            return (
              <option key={index} value={timeSlots + ":00"} selected={timeSlots === "12:00" + ":00"}>
                {moment(timeSlots, "HH:mm:ss").format(timeDisplayFormat(user?.timeDisplayFormat))}
              </option>
            );
          })}
      </select>
    );
  };

  const ruleDisplayNativeBilingue = (type) => {
    let newArrayLang = [];
    for (let i = 0; i < plans?.length; i++) {
      plans[i]?.studentPlanLanguages?.map((lang) =>
        plans[i]?.student?.studentLevelGrades?.filter((grade) => {
          if (grade.lingoLanguageId === lang.lingoLanguageId)
            newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
        }),
      );
    }

    if (lingoLanguageId === 1 && plans?.length > 0) {
      if (plans[0]?.plan?.multiLingo) {
        return (
          (lingoLanguageId === 1 || lingoLanguage?.flag === "US") &&
          newArrayLang?.some((item) => item.flag === "US" && !["A0", "A1"].includes(item.level))
        );
      }

      if (type === "studentlevel") {
        return newArrayLang?.some((item) => item.flag === "US" && ["A0", "A1"].includes(item.level));
      }
    } else if (lingoLanguageId === 4 && plans?.length > 0) {
      if (plans[0]?.plan.multiLingo) {
        return (
          (lingoLanguageId === 4 || lingoLanguage?.flag === "FR") &&
          newArrayLang?.some((item) => item.flag === "FR" && !["A0", "A1"].includes(item.level))
        );
      }

      if (type === "studentlevel") {
        return newArrayLang?.some((item) => item.flag === "FR" && ["A0", "A1"].includes(item.level));
      }
    } else {
      return false;
    }

    return newArrayLang.some(
      (item) => (item.flag === "US" || item.flag === "FR") && !["A0", "A1"].includes(item.level),
    );
  };

  useEffect(() => {
    const dateItem = scheduledDate !== "" ? moment(scheduledDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    const dateNow = moment(new Date());
    const date = moment(dateNow).format("YYYY-MM-DD");

    setFilteredTimeSlots(timeSlots);
    if (editClass) {
      setScheduledStart(userClass.scheduledStartTime);
    } else {
      setScheduledStart(timeSlots[24] + ":00");
      setScheduledEnd(timeSlots[25] + ":00");

      date !== dateItem && setScheduledStart(timeSlots[24] + ":00");
    }
    // eslint-disable-next-line
  }, [scheduledDate]);

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, [plans]);

  return (
    <>
      <Dialog open={openSchedule} onClose={closeSchedule} className="modalSchedule" classes={"modalSchedule"}>
        <div className="divSchedule">
          <LoadingComponent />
          {editClass && outLimitChangeAlert ? (
            <h2>{t("TITLE_CONFIRM_CHANGE_CLASS")}</h2>
          ) : (
            <h2>{title ? title : t("BTN_SCHEDULE_NEW_CLASS")}</h2>
          )}

          <div className="divider" />

          {editClass && outLimitChangeAlert ? (
            <div className="editClassInfo">
              <CiWarning color="#ffa500" size={52} />
              <p>{t("MESSAGE_CONFIRM_CHANGE_CLASS")}</p>
            </div>
          ) : (
            <div className="selectDays">
              <h3>{editClass ? t("CLASS_SCHEDULE_EDIT_MODAL_SUBTITLE") : t("CLASS_SCHEDULE_MODAL_SUBTITLE")}</h3>

              <div className="langPlan">
                <h4>{t("LANGUAGE")}:</h4>

                <div className="languagesPlan">
                  <ul>
                    {languages.filter((lang) => lang.studentPlanId === Number(studentPlanId)).length > 1
                      ? languages
                          .filter((lang) => lang.studentPlanId === Number(studentPlanId))
                          .map((lang, i) => (
                            <li key={"lang" + i}>
                              <div>
                                <label className={lingoLanguageId == lang.lingoLanguage.id ? "active" : ""}>
                                  {t(lang.lingoLanguage.description.toUpperCase())}
                                  <input
                                    type="radio"
                                    name="lingoLanguageId"
                                    value={lang.lingoLanguage.id}
                                    onClick={(e) => buttonLanguageHandleChange(e, lang.lingoLanguage)}
                                  />
                                </label>
                              </div>
                            </li>
                          ))
                      : languages.map((lang, i) => {
                          return (
                            <li key={"lang" + i}>
                              <div>
                                <label className={lingoLanguageId == lang.lingoLanguage.id ? "active" : ""}>
                                  {t(lang.lingoLanguage.description.toUpperCase())}
                                  <input
                                    type="radio"
                                    name="lingoLanguageId"
                                    value={lang.lingoLanguage.id}
                                    onClick={(e) => buttonLanguageHandleChange(e, lang.lingoLanguage)}
                                  />
                                </label>
                              </div>
                            </li>
                          );
                        })}
                  </ul>

                  <div className="plan">
                    <div>
                      <span>{t("PLAN")}:</span>
                      {getPlan()}
                    </div>
                  </div>
                </div>
              </div>

              {plans && !plans[0]?.studentPlanLanguages[0]?.lingoLanguage.customLang && (
                <div className="focus">
                  <h4>{t("FOCUS")}:</h4>

                  <ul>
                    <li>
                      <select name="focus" value={focus} onChange={handlerSubjectEspecific}>
                        <option value="Regular">{t("BTN_REGULAR")}</option>
                        <option value="Specific">{t("BTN_SPECIFIC")}</option>
                      </select>
                    </li>

                    {isVisibleText ? (
                      <input
                        type="text"
                        id="textSpecific"
                        name="textSpecific"
                        value={textSpecific}
                        onChange={handleChange}
                        className="input-lingo"
                        placeholder={t("CLASS_SUBJECT")}
                      />
                    ) : null}

                    <li>
                      <Popup
                        on={"hover"}
                        position={"right center"}
                        trigger={
                          <img
                            className="linguitoPNG"
                            src={linguitoPNG}
                            style={{ marginLeft: isVisibleText ? 10 : 0 }}
                          />
                        }
                        style={{ width: 300, backgroundColor: "red", zIndex: 999999999, marginLeft: 20 }}
                      >
                        <div style={{ width: 300 }}>
                          <p style={{ textAlign: "justify", color: "#555D67" }}>{t("MESSAGE_INFO_CONTENT_REGULAR")}</p>
                          <p style={{ textAlign: "justify", color: "#555D67" }}>{t("MESSAGE_INFO_CONTENT_SPECIFIC")}</p>
                        </div>
                      </Popup>
                    </li>
                  </ul>
                </div>
              )}

              <div className="time">
                <ul>
                  <li>
                    <span>{t("DATE")}:</span>
                    <div className="lineInputs">
                      <DatePicker
                        id="date"
                        showYearDropdown
                        showMonthDropdown
                        onChange={setDate}
                        name="scheduledDate"
                        todayButton={t("TODAY")}
                        selected={scheduledDate}
                        dateFormat={t("DATE_FORMAT")}
                        popperPlacement="bottom-start"
                        customInput={<InputDatepicker />}
                        calendarClassName="customCalendar"
                        placeholderText={t("DATE_FORMAT")}
                      />
                    </div>
                  </li>
                  <li>
                    <span>{t("BTN_START_TIME")}:</span>
                    {renderStartTime()}
                  </li>
                  <li>
                    <span>{t("BTN_NUMBER_CLASSES")}:</span>
                    <select name="numberOfClasses" value={numberOfClasses} onChange={(e) => handleChange(e)}>
                      <option value="Select">{t("SELECT")}</option>
                      <option value="1">1 </option>
                      <option value="2">2 </option>
                      <option value="3">3 </option>
                      <option value="4">4 </option>
                      <option value="5">5 </option>
                      <option value="6">6 </option>
                      <option value="7">7 </option>
                      <option value="8">8 </option>
                      <option value="9">9 </option>
                      <option value="10">10 </option>
                    </select>
                  </li>
                  <li>
                    <span>{t("BTN_END_TIME")}:</span>

                    <button className="button-blue">{calculaQtdAulas()}</button>
                  </li>
                </ul>
              </div>

              <div className="time buttonNativeBilingueRepeat">
                {ruleDisplayNativeBilingue() && (
                  <>
                    <h4>{t("WHAT_TYPE_OF_TEACHER")}</h4>

                    <ul>
                      <>
                        <li>
                          <button onClick={btnTeacherHandleChange} className={!nativoBtn ? "" : "active"} name="nativo">
                            {t("NATIVE")}
                          </button>
                        </li>
                        <li>
                          <button
                            name="bilingue"
                            onClick={btnTeacherHandleChange}
                            className={!bilingueBtn ? "" : "active"}
                          >
                            {t("BILINGUAL")}
                          </button>
                        </li>
                      </>
                      <li>
                        <Popup
                          on={"hover"}
                          style={{ width: 300 }}
                          position={"right center"}
                          trigger={<img className="linguitoPNG" src={linguitoPNG} />}
                        >
                          <div style={{ width: 300 }}>
                            <p style={{ textAlign: "justify", color: "#555D67" }}>
                              {t("MESSAGE_INFO_BILINGUE_NATIVO")}
                            </p>
                          </div>
                        </Popup>
                      </li>
                    </ul>
                  </>
                )}
              </div>

              {!editClass && (
                <>
                  <div className="time buttonNativeBilingueRepeat">
                    <h4>{t("REPEAT")}?</h4>

                    <ul>
                      <li>
                        <button onClick={btnRepeatHandleChange} className={showRepeat ? "" : "active"} name="no">
                          {t("BTN_NO")}
                        </button>
                      </li>
                      <li>
                        <button onClick={btnRepeatHandleChange} className={showRepeat ? "active" : ""} name="yes">
                          {t("BTN_YES")}
                        </button>
                      </li>
                      <li>
                        <Popup
                          on={"hover"}
                          position={"right center"}
                          trigger={<img className="linguitoPNG" src={linguitoPNG} />}
                          style={{ width: 300, backgroundColor: "red", zIndex: 999999999 }}
                        >
                          <div style={{ width: 300 }}>
                            <p style={{ textAlign: "justify", color: "#555D67" }}>{t("MESSAGE_INFO_REPEAT")}</p>
                          </div>
                        </Popup>
                      </li>
                    </ul>
                  </div>

                  <div id="repeatClass" className="repeatClass" style={{ display: showRepeat ? "block" : "none" }}>
                    <h4>{t("BTN_DAYS_TO_REPEAT_CLASS")}:</h4>
                    <ul>
                      <li>
                        <button id="WEEK_SUNDAY" value="0" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_SUNDAY")}
                        </button>
                      </li>
                      <li>
                        <button id="WEEK_MONDAY" value="1" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_MONDAY")}
                        </button>
                      </li>
                      <li>
                        <button id="WEEK_TUESDAY" value="2" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_TUESDAY")}
                        </button>
                      </li>
                      <li>
                        <button id="WEEK_WEDNESDAY" value="3" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_WEDNESDAY")}
                        </button>
                      </li>
                      <li>
                        <button id="WEEK_THURSDAY" value="4" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_THURSDAY")}
                        </button>
                      </li>
                      <li>
                        <button id="WEEK_FRIDAY" value="5" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_FRIDAY")}
                        </button>
                      </li>
                      <li>
                        <button id="WEEK_SATURDAY" value="6" onClick={(e) => btnHandleWeekDay(e)}>
                          {t("WEEK_SATURDAY")}
                        </button>
                      </li>
                    </ul>
                    <h4>{t("BTN_REPEAT_UNITIL")}:</h4>
                    <div className="lineInputs">
                      <DatePicker
                        id="repeatEnd"
                        name="repeatEnd"
                        showMonthDropdown
                        showYearDropdown
                        selected={repeatEnd}
                        onChange={setRepeatEnd}
                        todayButton={t("TODAY")}
                        dateFormat={t("DATE_FORMAT")}
                        popperPlacement="bottom-start"
                        customInput={<InputDatepicker />}
                        calendarClassName="customCalendar"
                        placeholderText={t("DATE_FORMAT")}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          <div className="divider" />

          <div className="buttons">
            <button onClick={closeSchedule} type="button">
              {t("BTN_BACK")}
            </button>

            {editClass && outLimitChangeAlert ? (
              <button className="button-blue" onClick={() => setOutLimitChangeAlert(false)}>
                {t("BTN_CONFIRM")}
              </button>
            ) : (
              <button
                className="button-blue"
                disabled={isButtonDisabled}
                onClick={(e) => (editClass ? handleSubmitEdit(e) : btnScheduleSubmit())}
              >
                {t("BTN_SCHEDULE")}
              </button>
            )}
          </div>
        </div>
      </Dialog>

      <SwarmModal
        openSwarm={openSwarm}
        postSchedule={postSchedule}
        alternativeTimes={alternativeTimes}
        alternativeTimesMessage={alternativeTimesMessage}
        {...props}
      />
      <AlertModal
        httpCode={httpCode}
        alertMsg={alertMsg}
        openAlert={openAlert}
        alertTitle={alertTitle}
        closeAlert={closeAlert}
        {...props}
      />
    </>
  );
}

export default ModalSchedule;
